<template>
  <section class="container">
    <h3 class="pb-4">Autoridades del Ministerio de Minería</h3>
    <h4>Ministro de Minería</h4>
    <p>Dr. Juan Pablo Perea Fontivero</p>

    <h4>Secretaría Técnica</h4>
    <ul>
      <li>Secretario Técnico: Ing. Pablo Fernandez</li>
      <li>
        Dirección de Registro Minero y Catastro: Dr. Hugo Sebastián Archerito
      </li>
      <li>Dirección de Despacho Minero: Dr. Leandro Bazán Fernandez</li>
      <li>Escribanía de Minas: Esc. Florencia Beltrán</li>
      <li>Dirección Técnica Geología Minera: Lic. Romina Noelia Gómez</li>
      <li>Consejo Minero: Ing. Eduardo Balmaceda y Dr. Ricardo Quiroga</li>
    </ul>

    <h4>Secretaría de Gestión Ambiental y Control Minero</h4>
    <ul>
      <li>Secretario: Lic. Roberto Moreno</li>
      <li>
        Centro de Investigación para la Prevención de la Coordinación Ambiental:
        Ing. Graciela Arredondo
      </li>
      <li>
        Dirección de Fiscalización Ambiental y Control Minero: Lic. Roberto Luna
      </li>
      <li>Dirección de Evaluación Ambiental Minera: Dra. Belén Hocevar</li>
      <li>
        Coordinador de Mina Veladero y Pascua Lama: Ing. Guillermo Serafini
      </li>
      <li>Coordinador de Mina Gualcamayo y Casposo: Daniel Roldán</li>
    </ul>

    <h4>Secretaría de Desarrollo Minero Sustentable</h4>
    <ul>
      <li>Secretario: CP Guillermo Olguín</li>
      <li>Dirección de Desarrollo Minero Sustentable: Lic. Mariana Azcona</li>
      <li>Dirección de Fiscalización de Ingresos: CP Jésica Cabrera</li>
      <li>Subsecretaria de Coordinación Administrativa: CP Lucía Maurín</li>
      <li>Contable: CP Julia Imazio</li>
      <li>Despacho Administrativo: Graciela Gómez</li>
      <li>Recursos Humanos: Lic. Nicolás Mercado</li>
    </ul>

    <p>
      <b>Dirección de Promoción, Difusión y Comunicación Minera:</b> Lic.
      Ángeles Irusta
    </p>
    <p>
      <b
        >Instituto Provincial de Exploraciones y Explotaciones Mineras
        (IPEEM):</b
      >
    </p>
    <p>Presidente: Lic. Natalia Marchese</p>
    <p>Vicepresidente: Ing. Ricardo Gutiérrez</p>
  </section>
</template>

<script>
import d from "../../data.json";

export default {
  name: "OrganigramaComponent",
  props: {
    titulo: String,
    subtitulo: String,
    columnas: String,
    filtros: Object,
  },
  data() {
    return {
      items: null,
      dataFile: Object,
    };
  },
  mounted() {
    this.dataFile = d;
    console.log(this.dataFile);
  },
  created() {
    this.items = this.dataFile.items;
  },
};
</script>
